import { gql } from 'graphql-request';
import { ChartIds } from 'src/shared/types';
export const speciesGroupsMetricsQuery = gql`
    query speciesGroupsMetricsData($projectId: String!, $fromDate: String, $toDate: String, $habitatAssay: String!) {
        speciesgroups: chart(
            projectId: $projectId
            chartId: "${ChartIds.SPECIES_GROUPS}",
            habitatAssay: $habitatAssay
            fromDate: $fromDate
            toDate: $toDate
        ) {
            data
        }
    }
`;

export type SpeciesGroupsMetricsQueryResult = {
    speciesgroups: {
        data: {
            metric: string;
            data: number;
        }[];
    };
};
